<!--
 * @Description:支付网关通道管理
 * @Author: xu wei
 * @Date: 2020-02-25 12:50:59
 * @LastEditTime: 2020-08-03 14:26:42
 * @LastEditors: gao shuai
 -->
<template>
  <div class="gs_container">
    <div class="gs_crumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item><span class="local">你的位置</span></el-breadcrumb-item>
        <el-breadcrumb-item>支付网关</el-breadcrumb-item>
        <el-breadcrumb-item>通道管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="opeartbox">
      <div class="pdb10">
        <el-button size="small" type="primary" @click="addpass=true">添加</el-button>
      </div>
    </div>
    <div class="gs_tablebox">
      <el-table ref="moduleTable" size="mini" :data="tableData" border style="width: 100%" stripe>
        <el-table-column type="index" label="编号" width="80">
        </el-table-column>
        <el-table-column prop="name" label="通道名称">
        </el-table-column>
        <el-table-column label="支持业务">
          <el-table-column label="支付宝">
            <template slot-scope="scope">
              <img v-if="scope.row.isAlipay" src="../../assets/images/suppor.png" alt="">
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column label="微信">
            <template slot-scope="scope">
              <img v-if="scope.row.isWechat" src="../../assets/images/suppor.png" alt="">
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column label="网银">
            <template slot-scope="scope">
              <img v-if="scope.row.isEbank" src="../../assets/images/suppor.png" alt="">
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column label="财付通">
            <template slot-scope="scope">
              <img v-if="scope.row.isTenpay" src="../../assets/images/suppor.png" alt="">
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column label="qq钱包">
            <template slot-scope="scope">
              <img v-if="scope.row.isQpay" src="../../assets/images/suppor.png" alt="">
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column label="蚂蚁花呗">
            <template slot-scope="scope">
              <img v-if="scope.row.isHbpay" src="../../assets/images/suppor.png" alt="">
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column label="银联扫码">
            <template slot-scope="scope">
              <img v-if="scope.row.isUnion" src="../../assets/images/suppor.png" alt="">
              <span v-else>--</span>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="状态">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.state" @change="switchchange(scope.row.id)" active-color="#4a90e2" inactive-color="#e4eaec">
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="操作" width='280'>
          <template slot-scope="scope">
            <el-button size="mini" type="info" @click="getinfo(scope.row.id)">编辑</el-button>
            <el-button size="mini" v-if="scope.row.isShare" @click="getbindinfo(scope.row.id)">绑定分账</el-button>
            <el-button size="mini" type="primary" @click="rateinfo(scope.row.id, scope.row.name)">费率</el-button>
            <el-button size="mini" type="danger" @click.prevent="handleClose(scope.row.id)">删除</el-button>

          </template>
        </el-table-column>
      </el-table>
      <div class="gs_pagenumber">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageIndex" :page-sizes="[10, 20, 30, 40]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
    </div>
    
    <el-dialog title="分账绑定" :visible.sync="bindShare" @close="editinit" custom-class="gs_dialog" width="630px" :close-on-click-modal="false">
      <div class="gs_tablestyle1" style="overflow-y: auto; height: 700px">
      <div class="addtable">
        <div class="tablebox">
          <table>
            <thead>
              <tr>
                <th>用户id</th>
                <th>用户名</th>
                <th>绑定信息</th>
                <th>操作</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item,i) in binddata" :key="'bind'+i">

                <el-input  size="small" v-model="item.galleryId" style="display: none"></el-input>
                
                <td>
                  <el-input size="small" :disabled="!item.addself"  v-model="item.applicationUserId" placeholder="用户id"></el-input>
                </td>
                <td>
                  <el-input size="small" disabled  v-model="item.userName" placeholder="用户名"></el-input>
                </td>
                <td>
                  <el-input size="small" v-model="item.bindInfo" placeholder="绑定信息"></el-input>
                </td>
                <td>
                  <el-button size="small" type="primary" @click="saveclick0(item)">保存</el-button>
                </td>
              </tr>
            </tbody>
          </table>
          <p class="tc pdt5 pdb5">
            <el-button size="small" type="primary" @click="addbind">添加</el-button>
          </p>
        </div>
      </div>
    </div>
    </el-dialog>
    
    <!-- 编辑通道弹框 -->
    <el-dialog title="编辑通道" :visible.sync="editChannel" @close="editinit" custom-class="gs_dialog" width="630px" :close-on-click-modal="false">
      <div class="opeartbox">
        <ul class="clearfix">
          <li>
            <span class='tit'>通道名称</span>
            <span class="txtbox" style="width:450px;">
              <el-input size="small" v-model="dilogedit.name"></el-input>
            </span>
          </li>
          <li>
            <span class='tit'>通道账号</span>
            <span class="txtbox" style="width:450px;">
              <el-input size="small" v-model="dilogedit.account"></el-input>
            </span>
          </li>
          <li>
            <span class='tit'>通道密钥</span>
            <span class="txtbox" style="width:450px;">
              <el-input size="small" v-model="dilogedit.Md5Key"></el-input>
            </span>
          </li>
          <li>
            <span class='tit'>通道公钥</span>
            <span class="txtbox" style="width:450px;">
              <el-input size="small" v-model="dilogedit.publicKey"></el-input>
            </span>
          </li>
          <li>
            <span class='tit'>通道私钥</span>
            <span class="txtbox" style="width:450px;">
              <el-input size="small" v-model="dilogedit.privateKey"></el-input>
            </span>
          </li>
          <li>
            <span class='tit'>提交地址</span>
            <span class="txtbox" style="width:450px;">
              <el-input size="small" v-model="dilogedit.requesturl"></el-input>
            </span>
          </li>
          <li>
            <span class='tit'>回调地址</span>
            <span class="txtbox" style="width:450px;">
              <el-input size="small" v-model="dilogedit.backurl"></el-input>
            </span>
          </li>
          <li>
            <span class='tit'>跳转页面</span>
            <span class="txtbox" style="width:450px;">
              <el-input size="small" v-model="dilogedit.pageurl"></el-input>
            </span>
          </li>
          <li>
            <span class='tit'>金额范围</span>
            <span class="txtbox">
              <el-input style="width:100px;" type="number" size="small" v-model="dilogedit.minAmount" placeholder="请输入内容"></el-input> --
              <el-input style="width:100px;" type="number" size="small" v-model="dilogedit.maxAmount" placeholder="请输入内容"></el-input>
            </span>
          </li>
          <li>
            <span class='tit'>跳转模式</span>
            <span>
              <el-radio-group v-model="dilogedit.isRedirect">
                <el-radio :label="true">重新定向跳</el-radio>
                <el-radio :label="false">直返二维码</el-radio>
              </el-radio-group>
              <span class="line_tip">若两种都支持，请按场景自由切换</span>
            </span>
          </li>
          <li>
            <span class='tit'>付款备注</span>
            <span class="txtbox" style="width:450px;">
              <el-input size="small" v-model="dilogedit.description" placeholder="付款时提示的备注、商品描述等，尽量避免写中文(视接口而定)"></el-input>
            </span>
          </li>
           <li>
            <span class='tit'>是否开启随机金额</span>
            <span>
              <el-radio-group v-model="dilogedit.isOpenRandomMoney">
                <el-radio :label="true">开启</el-radio>
                <el-radio :label="false">不开启</el-radio>
              </el-radio-group>
              <span class="line_tip">风控随机金额开启</span>
            </span>
          </li>
           <li>
            <span class='tit'>随机金额开启阈值</span>
            <span class="txtbox" style="width:395px;">
              <el-input size="small" v-model="dilogedit.randomStartingPoint" placeholder="付款超过阈值时产生随机金额" style="width:395px;"></el-input>
            </span>
          </li>
          <li>
            <span class='tit'>随机金额范围(单位元)</span>
            <span class="txtbox">
              <el-input style="width:100px;" type="number" size="small" v-model="dilogedit.minRandomMoney" placeholder="请输入内容"></el-input> --
              <el-input style="width:100px;" type="number" size="small" v-model="dilogedit.maxRandomMoney" placeholder="请输入内容"></el-input>
            </span>
          </li>
          <li>
            <span class='tit'>是否分账</span>
            <span>
              <el-radio-group v-model="dilogedit.isShare">
                <el-radio :label="true">是</el-radio>
                <el-radio :label="false">否</el-radio>
              </el-radio-group>
              <span class="line_tip">确定是否是分账通道</span>
            </span>
          </li>
          <li>
            <span class='tit'>备用字段1</span>
            <span class="txtbox" style="width:450px;">
              <el-input size="small" v-model="dilogedit.remark1" placeholder="备用字段1"></el-input>
            </span>
          </li>
           <li>
            <span class='tit'>备用字段2</span>
            <span class="txtbox" style="width:450px;">
              <el-input size="small" v-model="dilogedit.remark2" placeholder="备用字段2"></el-input>
            </span>
          </li>
           <li>
            <span class='tit'>备用字段3</span>
            <span class="txtbox" style="width:450px;">
              <el-input size="small" v-model="dilogedit.remark3" placeholder="备用字段3"></el-input>
            </span>
          </li>
        </ul>
      </div>
      <p class="tc pdt10 pdb10">
        <el-button size="small" type="primary" @click="editupdate">提交</el-button>
      </p>
    </el-dialog>
    <!-- 通道费率弹框 -->
    <el-dialog title="通道费率" :visible.sync="channelrate" @close="rateinit" custom-class="gs_dialog" width="950px">
      <div>
        <ul class="roadlist clearfix">
          <li>
            <span class="tit">通道</span>
            <div class="content">
              <div class="tc" style="line-height:32px;">{{throughName}}</div>
            </div>
          </li>
          <li>
            <span class="tit">费率</span>
            <div class="content">
              <el-input size="small" v-model="ratenum" type="number" @input="allratechange" placeholder="一键设置费率0--100"></el-input>
            </div>
          </li>
          <li>
            <span class="tit">地址</span>
            <div class="content">
              <el-input size="small" v-model="rateurl" @input="allurlchange" placeholder="一键设置提交地址"></el-input>
            </div>
          </li>
          <li v-for="(item,i) in ratelist" :key="'rate'+i">
            <span class="tit">{{item.productName}}</span>
            <div class="content">
              <el-input style="width:68px;display:inline-block" size="small" v-model="item.rate"></el-input>
              <el-input style="width:126px;display:inline-block;margin-left:5px;" size="small" v-model="item.requestUrl"></el-input>
            </div>
          </li>
        </ul>
        <p class="tc pdt10 pdb10">
          <el-button class="referring" size="small" type="primary" @click="rateupdate">提交</el-button>
        </p>
      </div>
    </el-dialog>
    <!-- 添加通道弹框 -->
    <el-dialog title="添加通道" :visible.sync="addpass" @close="addinit" custom-class="gs_dialog" width="620px">
      <div>
        <div>
          <el-checkbox-group v-model="addthroughlist" size="mini">
            <ul class="throughsel clearfix">
              <li v-for="(item,i) in throughsetlist" :key="'through'+i">
                <el-checkbox :label="item.id" border>{{item.name}}</el-checkbox>
              </li>
            </ul>
          </el-checkbox-group>
        </div>
        <p class="tc pdt10 pdb10">
          <el-button class="referring" size="small" type="primary" @click="addthrough">确认</el-button>
        </p>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      addthroughlist: [],
      throughsetlist: [],
      channelName: '', // 通道名称
      channelAccount: '', // 通道账号
      channelKey: '', // 通道密钥
      ontherecharge: '', // 金额范围上
      undertherecharge: '', // 通道名称下
      Scope: '', // 跳转模式
      remarks: '', // 付款备注
      chantid: '',
      pageIndex: 1, // 页码
      pageSize: 10, // 每页的条数
      total: 0, // 总数据的条数
      options: [],
      tableData: [],
      editChannel: false, // 编辑通道
      bindShare: false, //绑定分账
      dilogedit: {
        id: 0,
        mark: '',
        state: true,
        name: '',
        account: '',
        Md5Key: '',
        publicKey: '',
        privateKey: '',
        requesturl: '',
        backurl: '',
        pageurl: '',
        minAmount: 0.1,
        maxAmount: '',
        isRedirect: true,
        description: '',
        isOpenRandomMoney: false,
        minRandomMoney: 0,
        maxRandomMoney: 0,
        randomStartingPoint: 0,
        remark1: '',
        remark2: '',
        remark3: '',
        isShare: false,
        galleryProductId: 0,
      },
      channelrate: false, // 通道费率
      throughName: '',
      ratelist: [], // 费率列表
      ratenum: '',
      rateurl: '',
      rateid: '',
      addpass: false,// 添加通道弹框
      binddata: [] //绑定分账信息
    };
  },
  computed: {
    addpassinfo() {
      if (JSON.stringify(this.throughsetlist) === '[]') {
        return [];
      } else {
        let arr = [];
        this.addthroughlist.forEach((item) => {
          arr.push(this.throughsetlist.filter((li) => li.id === item)[0]);
        });
        console.log(arr);
        return arr;
      }
    }
  },
  methods: {
    // 通道列表
    async getlist() {
      this.$api.apay
        .throughlist({
          PageNumber: this.pageIndex,
          PageSize: this.pageSize
        })
        .then((data) => {
          if (data.status === 204) {
            this.tableData = [];
            this.total = 0;
          } else if (data.status === 200) {
            this.tableData = data.data;
            this.total = JSON.parse(data.headers['x-pagination']).TotalCount;
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 添加通道的list
    addlist() {
      this.$api.apay
        .throughset()
        .then((data) => {
          if (data.status === 200) {
            this.throughsetlist = data.data;
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 添加通道的确认
    addthrough() {
      this.$api.apay
        .addthrough(this.addpassinfo)
        .then((data) => {
          if (data.status === 200) {
            this.$messageSuccess('添加成功！');
            this.addpass = false;
            this.getlist();
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 添加通道弹框初始化
    addinit() {
      this.addthroughlist = [];
    },
    // 删除通道
    deletethrough(data) {
      this.$api.apay
        .deletethrough({ id: data })
        .then((data) => {
          if (data.status === 200) {
            this.$messageSuccess('删除成功！');
            if (this.tableData.length === 1) {
              this.pageIndex = this.pageIndex === 1 ? 1 : this.pageIndex - 1;
            }
            this.getlist();
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 删除通道提示
    handleClose(data) {
      this.$confirm('是否确实删除该通道?')
        .then(() => {
          this.deletethrough(data);
        })
        .catch(() => {});
    },
    // 切换状态
    switchchange(data) {
      this.$api.apay
        .switchstate({ id: data })
        .then((data) => {
          if (data.status === 200) {
            this.$messageSuccess('切换成功！');
            this.getlist();
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 获取编辑信息
    getinfo(data) {
      this.editChannel = true;
      this.$api.apay
        .throughinfo({ id: data })
        .then((data) => {
          if (data.status === 200) {
            this.dilogedit.id = data.data.id;
            this.dilogedit.mark = data.data.mark;
            this.dilogedit.state = data.data.state;
            this.dilogedit.name = data.data.name;
            this.dilogedit.account = data.data.account;
            this.dilogedit.Md5Key = data.data.md5Key;
            this.dilogedit.privateKey = data.data.privateKey;
            this.dilogedit.publicKey = data.data.publicKey;
            this.dilogedit.minAmount = data.data.minAmount;
            this.dilogedit.maxAmount = data.data.maxAmount;
            this.dilogedit.isRedirect = data.data.isRedirect;
            this.dilogedit.description = data.data.description;
            this.dilogedit.requesturl = data.data.requestUrl;
            this.dilogedit.backurl = data.data.postBackUrl;
            this.dilogedit.pageurl = data.data.notifyUrl;
            this.dilogedit.isOpenRandomMoney = data.data.isOpenRandomMoney;
            this.dilogedit.minRandomMoney = data.data.minRandomMoney;
            this.dilogedit.maxRandomMoney = data.data.maxRandomMoney;
            this.dilogedit.randomStartingPoint = data.data.randomStartingPoint;
            this.dilogedit.remark1 = data.data.remark1;
            this.dilogedit.remark2 = data.data.remark2;
            this.dilogedit.remark3 = data.data.remark3;
            this.dilogedit.isShare = data.data.isShare;
            this.dilogedit.galleryProductId = data.data.galleryProductId;
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 编辑更新
    editupdate() {
      if (parseFloat(this.dilogedit.minAmount) < 0) {
        this.$messageError('金额范围不能小于0');
        return;
      } else if (parseFloat(this.dilogedit.maxAmount) < 0) {
        this.$messageError('金额范围不能小于0');
        return;
      } else if (parseFloat(this.dilogedit.minRandomMoney) < 0) {
        this.$messageError('金额范围不能小于0');
        return;
      } else if (parseFloat(this.dilogedit.maxRandomMoney) < 0) {
        this.$messageError('金额范围不能小于0');
        return;
      } else if (parseFloat(this.dilogedit.randomStartingPoint) < 0) {
        this.$messageError('金额范围不能小于0');
        return;
      }
      this.$api.apay
        .throughupdate({
          id: this.dilogedit.id,
          mark: this.dilogedit.mark,
          state: this.dilogedit.state,
          name: this.dilogedit.name,
          account: this.dilogedit.account,
          Md5Key: this.dilogedit.Md5Key,
          privateKey: this.dilogedit.privateKey,
          publicKey: this.dilogedit.publicKey,
          RequestUrl: this.dilogedit.requesturl,
          PostBackUrl: this.dilogedit.backurl,
          NotifyUrl: this.dilogedit.pageurl,
          minAmount:
            this.dilogedit.minAmount === ''
              ? 0
              : parseFloat(this.dilogedit.minAmount),
          maxAmount:
            this.dilogedit.maxAmount === ''
              ? 0
              : parseFloat(this.dilogedit.maxAmount),
          isRedirect: this.dilogedit.isRedirect,
          description: this.dilogedit.description,
          isOpenRandomMoney: this.dilogedit.isOpenRandomMoney,
          minRandomMoney:
            this.dilogedit.minRandomMoney === ''
              ? 0
              : parseFloat(this.dilogedit.minRandomMoney),
          maxRandomMoney:
            this.dilogedit.maxRandomMoney === ''
              ? 0
              : parseFloat(this.dilogedit.maxRandomMoney),
          randomStartingPoint:
            this.dilogedit.randomStartingPoint === ''
              ? 0
              : parseFloat(this.dilogedit.randomStartingPoint),
          isShare: this.dilogedit.isShare, 
          galleryProductId: this.dilogedit.galleryProductId, 
          remark1: this.dilogedit.remark1,
          remark2: this.dilogedit.remark2,
          remark3: this.dilogedit.remark3
        })
        .then((data) => {
          if (data.status === 200) {
            this.editChannel = false;
            this.$messageSuccess('更新成功！');
            this.getlist();
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 编辑弹框的初始化
    editinit() {
      this.dilogedit.id = '';
      this.dilogedit.mark = '';
      this.dilogedit.state = true;
      this.dilogedit.name = '';
      this.dilogedit.account = '';
      this.dilogedit.Md5Key = '';
      this.dilogedit.privateKey = '';
      this.dilogedit.requesturl = '';
      this.dilogedit.backurl = '';
      this.dilogedit.pageurl = '';
      this.dilogedit.publicKey = '';
      this.dilogedit.minAmount = '';
      this.dilogedit.maxAmount = '';
      this.dilogedit.isRedirect = '';
      this.dilogedit.description = '';
      this.dilogedit.isOpenRandomMoney = false;
      this.dilogedit.minRandomMoney = 0;
      this.dilogedit.maxRandomMoney = 0;
      this.dilogedit.randomStartingPoint = 5;
      this.dilogedit.remark1 = '';
      this.dilogedit.remark2 = '';
      this.dilogedit.remark3 = '';
    },
    // 费率信息
    rateinfo(id, name) {
      this.$api.apay
        .rateinfo({ Id: id })
        .then((data) => {
          if (data.status === 200) {
            this.throughName = name;
            this.ratelist = data.data;
            this.rateid = id;
            this.channelrate = true;
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 一键设置费率
    allratechange() {
      this.ratelist.forEach((item) => {
        item.rate = this.ratenum;
      });
    },
    // 一键设置费率
    allurlchange() {
      this.ratelist.forEach((item) => {
        item.requestUrl = this.rateurl;
      });
    },
    // 更新费率
    rateupdate() {
      let flag = true;
      this.ratelist.forEach((item) => {
        if (item.rate === '') {
          flag = false;
        }
      });
      if (flag) {
        this.$api.apay
          .rateupdate({
            id: this.rateid,
            managerGalleryRateViewModels: this.ratelist.map((item) => {
              return {
                productId: item.productId,
                productName: item.productName,
                rate: parseFloat(item.rate),
                //requestUrl: item.requestUrl
              };
            })
          })
          .then((data) => {
            if (data.status === 200) {
              this.$messageSuccess('费率更新成功！');
              this.channelrate = false;
            }
          })
          .catch((err) => {
            this.$messageError(err.message);
          });
      } else {
        this.$messageError('费率不能为空值！');
      }
    },
    // 费率弹框初始化
    rateinit() {
      this.ratenum = '';
      this.rateurl = '';
      this.rateid = '';
      this.ratelist = [];
      this.throughName = '';
    },
    // 当每页条数变化时
    handleSizeChange(data) {
      this.pageSize = data;
      this.pageIndex = 1;
      this.getlist();
    },
    // 当前的页码变化时
    handleCurrentChange(data) {
      this.pageIndex = data;
      this.getlist();
    },
    // 获取绑定信息
    getbindinfo(data) {
      this.bindShare = true;
      this.dilogedit.id = data;
      //这里查询此galleryid的所有绑定信息
      this.$api.apay
        .throughbindinfo({ id: data })
        .then((data) => {
          if (data.status === 200) {
            this.binddata = data.data;
          }
        }).catch((err) => {
          this.$messageError(err.message);
        });

    },
    addbind() {
      this.binddata.push({
        applicationUserId: 0,
        userName: '',
        bindInfo: '',
        galleryId:  this.dilogedit.id,
        addself: true
      });
    },
    // 添加绑定信息保存点击
    saveclick0(data) {
      if (data.addself) {
        this.savebind(data);
      } else {
        this.editbind(data);
      }
    },
    // 添加绑定分账保存
    async savebind(data) {
      if (data.applicationUserId === '') {
        this.$messageError('用户id不能为空');
        return;
      } else if (data.bindInfo === '') {
        this.$messageError('绑定信息不能为空');
        return;
      }
      this.$api.apay
        .bindadd({
          id: 0,
          applicationUserId: parseInt(data.applicationUserId),
          bindInfo: data.bindInfo,
          galleryId: data.galleryId,
        })
        .then((data) => {
          if (data.status === 200) {
            this.$messageSuccess('添加成功！');
            this.getlist();
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 分账绑定编辑
    async editbind(data) {
      if (data.applicationUserId === '') {
        this.$messageError('用户id不能为空');
        return;
      } else if (data.bindInfo === '') {
        this.$messageError('绑定信息不能为空');
        return;
      }
      this.$api.apay
        .bindedit({
          id: data.id,
          applicationUserId: parseInt(data.applicationUserId),
          bindInfo: data.bindInfo,
          galleryId: data.galleryId,
        })
        .then((data) => {
          if (data.status === 200) {
            this.$messageSuccess('编辑成功！');
            this.getlist();
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },

  },
  created() {
    this.getlist();
    this.addlist();
  },
  
};
</script>

<style lang="scss" scoped>
.opeartbox {
  padding: 15px 20px 5px;
  background: #fff;
  ul {
    li {
      float: left;
      margin-right: 15px;
      margin-bottom: 10px;
      height: 32px;
      line-height: 32px;
      .tit {
        font-size: 14px;
        color: #2d2d2d;
        margin-right: 5px;
      }
      .txtbox {
        display: inline-block;
      }
    }
  }
}
.line_tip {
  color: red;
  font-size: 14px;
  margin-left: 20px;
}
.tablebox {
  text-align: center;
  td,
  th {
    border: 1px solid #e3e3e3;
    height: 50px;
  }
}
.owe {
  width: 52px;
}
.long {
  width: 150px;
  padding-left: 10px;
}
.referring {
  margin: 10px;
}
.checkbox td {
  border: 1px solid #e3e3e3;
  padding: 10px 20px;
}
.roadlist {
  border: 1px solid #ccc;
  width: 903px;
  li {
    float: left;
    width: 300px;
    height: 40px;
    border-bottom: 1px solid #ccc;
    border-right: 1px solid #ccc;
    margin-bottom: -1px;
    &:nth-child(3n + 3) {
      border-right: none;
    }
    .tit {
      float: left;
      width: 80px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      border-right: 1px solid #ccc;
    }
    .content {
      float: left;
      width: 200px;
      height: 32px;
      padding: 4px 9px;
      text-align: center;
    }
  }
}
.throughsel {
  li {
    float: left;
    padding: 10px;
    width: 120px;
    text-align: center;
    border-right: 1px solid #ccc;
    border-bottom: 1px solid #ccc;
    &:nth-child(1),
    &:nth-child(2),
    &:nth-child(3),
    &:nth-child(4) {
      border-top: 1px solid #ccc;
    }
    &:nth-child(4n + 1) {
      border-left: 1px solid #ccc;
    }
  }
}

.gs_tablestyle1 {
  .addtable {
    position: relative;
    //padding-left: 135px;
    background: #fff;
    
    .tablebox {
      table {
        width: 100%;
        th {
          height: 40px;
          font-size: 14px;
          color: #3e3e3e;
          background: #e4eaec;
          font-weight: normal;
          // border: 1px solid #bfbfbf;
        }
        td {
          height: 50px;
          border: 1px solid #e4eaec;
          text-align: center;
          padding: 0 8px;
        }
      }
    }
  }
}

</style>
